import { render, staticRenderFns } from "./RespondedMessage.vue?vue&type=template&id=381649af"
import script from "./RespondedMessage.vue?vue&type=script&lang=js"
export * from "./RespondedMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports